import {
  CalendarIcon,
  ChartIcon,
  ChartPieIcon,
  HelpIcon,
  InboxIcon,
  LightBulbIcon,
  MessagesSidebarIcon,
  NotepadIcon,
  ReceiptIcon,
  SettingsIcon,
  SquaresIcon,
} from '@/assets/icons';
import { GroupItem } from '@/components/organisms';
import { RoutesEnum } from '@/enums';

const HELP_RESOURCES_EXTERNAL_URL = 'https://www.chirpee.co/resources/';

const SIDEBAR_HELP_ITEM_KEY = '__sidebar-help-resources__';

export const DASHBOARD_SIDEBAR_GROUPS: GroupItem[] = [
  {
    id: '1',
    items: [{ title: 'Getting started', url: RoutesEnum.GET_STARTED, icon: LightBulbIcon }],
  },
  {
    id: '2',
    groupLabel: 'Daily survey',
    items: [
      {
        title: 'Overview',
        url: RoutesEnum.DAILY_SURVEY_OVERVIEW,
        icon: ChartIcon,
      },
      {
        title: 'Question history',
        url: RoutesEnum.QUESTION_HiSTORY,
        icon: InboxIcon,
      },
      {
        title: 'Leader insights',
        url: RoutesEnum.LEADER_INSIGHTS,
        icon: ChartPieIcon,
      },
      {
        title: 'Data explorer',
        url: RoutesEnum.DATA_EXPLORER,
        icon: NotepadIcon,
      },
      {
        title: 'Management',
        icon: MessagesSidebarIcon,
        url: RoutesEnum.MANAGEMENT,
        subitems: [
          {
            title: 'Question library',
            url: RoutesEnum.MANAGEMENT_QUESTION_LIBRARY,
            icon: MessagesSidebarIcon,
          },
          {
            title: 'Question schedule',
            url: RoutesEnum.MANAGEMENT_QUESTION_SCHEDULE,
            icon: CalendarIcon,
          },
        ],
      },
    ],
  },
  {
    id: '3',
    groupLabel: 'Surveys',
    items: [
      {
        title: 'Overview',
        url: RoutesEnum.SURVEYS_OVERVIEW,
        icon: ReceiptIcon,
      },
      {
        title: 'Templates',
        url: RoutesEnum.SURVEYS_TEMPLATES,
        icon: SquaresIcon,
      },
    ],
  },
  {
    id: '4',
    items: [
      {
        title: 'Settings',
        url: RoutesEnum.SETTINGS,
        icon: SettingsIcon,
      },
      {
        title: 'Help and resources',
        url: SIDEBAR_HELP_ITEM_KEY,
        icon: HelpIcon,
        externalHref: HELP_RESOURCES_EXTERNAL_URL,
      },
    ],
  },
];
